import { useState, useCallback } from 'react';

export type View = 'loading' | 'lobby' | 'game' | 'expired' | 'error' | 'anonymous';

export function useView(initial: View = 'loading') {
  const [view, setView] = useState<View>(initial);
  // SPA view swaps reuse the same document, so the browser never resets
  // window scroll the way a real page load would — do it on every transition.
  const go = useCallback((next: View) => {
    window.scrollTo(0, 0);
    setView(next);
  }, []);
  return {
    view,
    goLoading: useCallback(() => go('loading'), [go]),
    goLobby: useCallback(() => go('lobby'), [go]),
    goGame: useCallback(() => go('game'), [go]),
    goExpired: useCallback(() => go('expired'), [go]),
    goError: useCallback(() => go('error'), [go]),
    goAnonymous: useCallback(() => go('anonymous'), [go]),
  };
}
